// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"897":"a1140623","8965":"ecab7f90"}[chunkId] + ".js";
};